import distributorInventory from "@/services/api/distributorInventory";
import { handleResponse } from "@/services/axios";
import { saveAsExcelFile } from "@/services/excelService/excelSevice";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface LoadingState {
    inventory: boolean;
    export: boolean;
}

interface SaleOrderState {
    distributorInventoryList: any[];
    loading: LoadingState;
    error: string | null;
}

const initialState: SaleOrderState = {
    distributorInventoryList: [],
    loading: {
        inventory: false,
        export: false,
    },
    error: null,
};

export const getDistributorInventoryList = createAsyncThunk(
    "inventory/getDistributorInventoryList",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await distributorInventory.getDistributorInventoryList(data);
            return handleResponse(response, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to fetch distributor inventory",
            );
        }
    },
);

export const getInventoryExport = createAsyncThunk(
    "inventory/getInventoryExport",
    async (data: any, { rejectWithValue }) => {
        try {
            const response = await distributorInventory.getInventoryExport(data);
            return saveAsExcelFile(response, "Distributor_Inventory");
        } catch (err: any) {
            return rejectWithValue(
                err?.response?.data?.message || "Failed to export",
            );
        }
    },
);

const distributorInventorySlice = createSlice({
    name: "inventory",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDistributorInventoryList.pending, (state) => {
                state.loading.inventory = true;
                state.error = null;
                state.distributorInventoryList = [];
            })
            .addCase(getDistributorInventoryList.fulfilled, (state, action) => {
                state.loading.inventory = false;
                state.distributorInventoryList = action.payload || [];
            })
            .addCase(getDistributorInventoryList.rejected, (state, action) => {
                state.loading.inventory = false;
                state.error = action.payload as string;
            })

            .addCase(getInventoryExport.pending, (state) => {
                state.loading.export = true;
                state.error = null;
            })
            .addCase(getInventoryExport.fulfilled, (state, action) => {
                state.loading.export = false;
            })
            .addCase(getInventoryExport.rejected, (state, action) => {
                state.loading.export = false;
                state.error = action.payload as string;
            });
    },
});

export default distributorInventorySlice.reducer;
